import { imgixHost } from 'src/config'
import Model, { ID, JsonObject, MODEL_LEVEL } from 'src/models/model'
import Tax from 'src/models/order/Tax'
import OrderItem from 'src/models/order-item/OrderItem'
import IssuedVoucherPackage from 'src/models/voucher/IssuedVoucherPackage'
import IssuedVoucherPackageVoucher from 'src/models/voucher/IssuedVoucherPackageVoucher'
import Voucher from 'src/models/voucher/Voucher'
import VoucherType from 'src/models/voucher/VoucherType'

export const VOUCHER_PACKAGE_CARD_TYPES = {
  SHARED: 'shared',
  CONSECUTIVE: 'consecutive'
}
VOUCHER_PACKAGE_CARD_TYPES.ALL = _.values(VOUCHER_PACKAGE_CARD_TYPES)

export default class VoucherPackage extends Model {
  static name = 'VoucherPackage'

  static isConfiguration = true

  static versioned = true

  static level = MODEL_LEVEL.CIRCUIT

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Promotions]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        default: null,
        translatable: true
      },
      description: {
        type: String,
        default: null,
        translatable: true
      },
      image: {
        type: String,
        default: null
      },
      taxable: {
        type: Boolean,
        default: false
      },
      taxes: {
        type: [Tax],
        default: () => ([]),
        reference: true
      },
      imageParams: {
        type: String,
        default: 'fit=crop&h=400&w=600&fm=jpeg&auto=format',
        local: true
      },
      voucherTypes: {
        type: [VoucherType],
        reference: true
      },
      voucherTypeOptions: {
        type: JsonObject,
        default: () => ({})
      }
    }

    this.computed = {
      imageUrl () {
        if (!this.image) return

        return `${imgixHost}/${this.image}?${this.imageParams}`
      },
      price () {
        let price = 0

        _.each(this.voucherTypes.data, voucherType => {
          price += voucherType.price * (this.voucherTypeOptions[voucherType.id]?.count ?? 0)
        })

        return price
      },
      formattedVoucherTypeOptions () {
        const formattedVoucherTypeOptions = []

        _.each(this.voucherTypes.data, voucherType => {
          formattedVoucherTypeOptions.push(`${(this.voucherTypeOptions[voucherType.id]?.count ?? 0)} ${_.startCase(this.voucherTypeOptions[voucherType.id]?.card_type)} ${voucherType.name}`)
        })

        return formattedVoucherTypeOptions
      }
    }

    this.paginate = true
  }

  get voucherPackageOrderItem () {
    let issuedVoucherPackage = null
    const issuedVoucherPackages = []

    if (this.voucherTypes.data.length === 1) {
      issuedVoucherPackage = this.createIssuedVoucherPackage(this.voucherTypes.data[0].id)
    } else {
      _.each(this.voucherTypes.data, voucherType => {
        issuedVoucherPackages.push(this.createIssuedVoucherPackage(voucherType.id))
      })

      issuedVoucherPackage = new IssuedVoucherPackage({
        voucherPackageId: this.id,
        issuedVoucherPackages,
        card: null
      })
    }

    return new OrderItem({
      type: 'voucher-package-purchase',
      issuedVoucherPackage,
      voucher: null,
      voucherType: null,
      discount: null
    })
  }

  createIssuedVoucherPackage (voucherTypeId) {
    const issuedVoucherPackageVouchers = []
    const vouchers = []

    for (let i = 0; i < this.voucherTypeOptions[voucherTypeId].count; ++i) {
      vouchers.push(new Voucher({
        voucherTypeId,
        card: null
      }))
    }

    _.each(vouchers, voucher => issuedVoucherPackageVouchers.push(new IssuedVoucherPackageVoucher({
      voucher,
      issuedVoucherPackage: null
    })))

    return new IssuedVoucherPackage({
      voucherPackageId: this.id,
      voucherTypeId,
      issuedVoucherPackageVouchers,
      card: null
    })
  }
}
